module.exports = __webpack_public_path__ + "img/CH01-010-011.899d39a3.jpg";